import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BACKEND_URL } from "constants";
import { getUserState } from "../../app/selector";
import PhotoViewer from "../common/photo/PhotoViewer";

const Dashboard = () => {
  const { user } = useSelector(getUserState);

  const [photos, setPhotos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !user.user_id) return;

    const fetchPhotos = async () => {
      setIsLoading(true);

      try {
        const payload = { user_id: user.user_id };
        const response = await axios.post(`${BACKEND_URL}/photos/by_user_id`, payload);
        setPhotos(response.data);
      } catch (e) {
        console.error("Failed to fetch photos:", e);
        setError("Could not load photos. Please check your connection.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPhotos();
  }, [user]);

  // Perfectly matched loading state for Dashboard
  // if (isLoading) {
  //   return (
  //     <div
  //       className="content-block gallery bg-light p-4 rounded d-flex flex-column justify-content-center align-items-center w-100"

  //     >

  //       <h5 className="mt-4 text-muted text-center">Loading your photos...</h5>
  //     </div>
  //   );
  // }

  if (error) {
    return (
      <div
        className="content-block gallery bg-light p-4 rounded d-flex justify-content-center align-items-center w-100 text-center"

      >
        <h5 className="text-danger">{error}</h5>
      </div>
    );
  }

  return (
    <div className="content-block gallery bg-light p-3 rounded">
      <PhotoViewer
        photosToShow={photos}
        title="My Photos"
        allowOperations={false}
      />
    </div>
  );
};

export default Dashboard;